<mat-button-toggle-group
  class="eiq-toggle-buttons__container"
  [attr.data-testid]="testId() ? testId() + '-toggle-buttons' : null"
  [ngClass]="'eiq-toggle-button-' + color()"
  [formControl]="toggleCtrl()"
  [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
>
  @for (toggleItem of toggleList(); track toggleItem) {
    <mat-button-toggle [value]="toggleItem.value" [disableRipple]="true">
      @if (toggleItem.icon) {
        <fa-icon [icon]="toggleItem.icon"></fa-icon>
      }
      {{ toggleItem.text }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
